<template>
    <div class="h1-wrapper">
        <h1 class="hh1" @click="toggleContent">
            <slot></slot>
            <span v-if="hasContent" class="toggle-btn">
                {{ isHidden ? '+' : '-' }}
            </span>
        </h1>
        <div v-if="hasContent" class="content" :class="{ hidden: isHidden }">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        hide: {
            type: Boolean,
            default: true // 改为 false，让传入的 hide 属性可以覆盖默认行为
        }
    },
    data() {
        return {
            isHidden: true // 默认为折叠状态
        }
    },
    created() {
        console.log(11);
        // 如果有内容则使用默认折叠状态，否则不折叠
        this.isHidden = this.hasContent ? true : false;
        // 如果传入了 hide 属性，则使用传入的值
        if (this.hide !== undefined) {
            this.isHidden = this.hide;
        }
    },
    computed: {
        hasContent() {
            console.log(!!this.$slots.content);
            return !!this.$slots.content;
        }
    },
    methods: {
        toggleContent() {
            if(!!this.$slots.content === false) return;
            console.log('toggleContent');
            this.isHidden = !this.isHidden
        }
    }
}
</script>

<style lang="scss" scoped>
.h1-wrapper {
    margin: 20px 0;
}

.hh1 {
    cursor: pointer;
    text-align: center;
    font-size: 30px;
    color: #333;
    font-weight: bold;
    line-height: 1.5;
    padding: 10px 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

}

.toggle-btn {
    cursor: pointer;
    font-size: 24px;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 50%;
    background: #f5f5f5;

}

.content {
    overflow: hidden;
    transition: all 0.3s ease;
    max-height: 2000px;
    opacity: 1;
    
    &.hidden {
        max-height: 0;
        opacity: 0;
        margin: 0;
    }
}
</style>